import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { FaCode, FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import About from './pages/About';
import Inquiry from './pages/Inquiry';
import Projects from './pages/Projects';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';

function Home() {
  return (
    <>
      <div className="hero-section">
        <div className="hero-content">
          <h1 style={{textAlign: 'center'}}>P R O J E C T  
            <br></br><div style={{position: 'relative', textAlign: 'center'}}>P O W E R <span style={{fontSize: '1rem', display: 'inline'}}>BY CW</span></div></h1>
          <p className="subtitle">Delivering custom engineering solutions and system integration to enhance precision, efficiency, and automation.</p>
          <div className="cta-buttons">
            <a href="https://wa.me/60162865881" className="cta-button primary">Contact Us</a>
            <a href="/inquiry" className="cta-button secondary">Learn More</a>
          </div>
        </div>
      </div>

      <div className="info-section">
        <div className="info-container">
          <div className="info-card">
            <FaCode className="info-icon" />
            <h2>Our Expertise</h2>
            <p>Specializing in custom engineering solutions, system integration, and automation technologies to optimize your operations.</p>
          </div>

          <div className="info-card contact-card">
            <h2>Get in Touch</h2>
            <div className="contact-details">
                <div className="contact-item address">
                <FaMapMarkerAlt className="contact-icon" />
                <div className="contact-text">
                  <p>70-1, Jalan PJS 11/7, Bandar Sunway</p>
                  <p>47500, Subang Jaya, Selangor</p>
                </div>
              </div>
              <div className="contact-item">
                <FaPhone className="contact-icon" />
                <div className="contact-text">
                  <p>+60 16-286 5881</p>
                </div>
              </div>
              <div className="contact-item">
                <FaEnvelope className="contact-icon" />
                <div className="contact-text">
                  <p>sales@projectpowerbycw.com</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/inquiry" element={<Inquiry />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
